import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ddc074c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view w-100 h-100 select-product-view" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "card-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderTitleWithSearch = _resolveComponent("HeaderTitleWithSearch")!
  const _component_ProductCard = _resolveComponent("ProductCard")!
  const _component_back_and_cancel_footer = _resolveComponent("back-and-cancel-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderTitleWithSearch, {
      title: _ctx.$t('cashier.label.products'),
      rows: _ctx.productsView,
      onOnSelect: _ctx.onSelect,
      onChangeSearchText: _ctx.changeSearchText
    }, null, 8, ["title", "rows", "onOnSelect", "onChangeSearchText"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
          return (_openBlock(), _createBlock(_component_ProductCard, {
            product: product,
            key: product.id,
            highlighted: _ctx.orderProducts.some((x) => x == product.id)
          }, null, 8, ["product", "highlighted"]))
        }), 128))
      ]),
      _createVNode(_component_back_and_cancel_footer)
    ])
  ]))
}